class Monitoring.Methods.SafelyExecutor

  # la idea es la siguiente:
  # 1) al hacer execute() el bloque se ejecuta sincronicamente
  # 2) si eso falla, se ejecuta con un _.defer
  # 3) si eso falla, se espera 1 segundo y se reintenta asincronicamente
  # 4) si eso falla, se hacen 4 reintentos mas, 1 segundo entre uno y otro
  # 5) si todos los intentos fallaron, se arroja la ultima exception obtenida
  # el valor de retorno esperado para execute() es un booleano

  # ejemplo:
  # block = () -> mi_codigo
  # safely_executor = new SafelyExecutor(block)
  # safely_executor.execute()

  constructor: (block) ->
    @block = block
    @exception = undefined

  execute: () ->
    executed = @executeSynchronously()
    return true if executed
    @executeDefered () => @executeInIntervals(4, 1000)
    false

  executeSynchronously: () ->
    try
      @block()
      true
    catch exception
      @exception = exception
      false

  executeDefered: (onFailure) ->
    console.log('going to execute defered')
    _.defer () =>
      console.log('executing defered')
      executed = @executeSynchronously()
      return true if executed
      onFailure()

  executeInIntervals: (retries, interval) ->
    console.log('going to execute in intervals')
    throw(@exception) unless retries >= 0
    wrappedCall = () =>
      console.log('executing interval')
      executed = @executeSynchronously()
      return true if executed
      @executeInIntervals(retries - 1, interval)
    timeoutId = setTimeout(wrappedCall, interval)

window.SafelyExecutor = Monitoring.Methods.SafelyExecutor
